export enum ArticleType {
  ARTICLE = 'article',
  CONTRIBUTION = 'contribution',
  TRAINING = 'training',
  CREDITS = 'credits',
}

export interface Article {
  id_item: string;
  id_product: string;
  type: ArticleType;
  title: string;
  description: string;
  tooltip: string;
  subject: string|null;
  level: string|null;
  price: string;
  brand: string;
  id_subtype: string;
  product_subtype: string;
  visible: '1'|'0';
  start: string;
  end: string;
  last_updated: string;
  is_addon: '1'|'0';
}

export interface AddOn {
  id_item: string;
  id_product: string;
  type: ArticleType;
  title: string;
  description: string;
  tooltip: string;
  subject: string|null;
  level: string|null;
  price: string;
  brand: string;
  id_subtype: string;
  product_subtype: string;
  visible: '1'|'0';
  start: string;
  end: string;
  last_updated: string;
  is_addon: '1'|'0';
}
